interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const go = (target: number) => {
    if (target < 1 || target > totalPages) return;
    onChange(target);
  };

  return (
    <nav className="flex items-center justify-center gap-1.5 pt-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page === 1}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/80 bg-background-50 text-foreground-600 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => go(item)}
          className={`h-9 min-w-9 rounded-md px-2 text-sm transition ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300/80 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/80 bg-background-50 text-foreground-600 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}